import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../authentication/AuthProvider';
import routes from './Routes';

const AuthenticationRoute = () => {
    const { currentUser } = useAuth();

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return !currentUser ? <Outlet /> : <Navigate to={routes.app.matches.build()} />;
}

export default AuthenticationRoute;